import { useCallback, useState } from "react";
import DefaultLayerSelector from "./DefaultLayerSelector";
import HydroLayerSelector from "./HydroLayerSelector";
import SatelliteLayerSelector from "./SatelliteLayerSelector";

/**
 * The Map Layer Selector Component
 * @param {{
 *  "onSelect": () => void,
 *  "selected": string
 * }} props
 * @returns import("react").JSX.Element
 */
export default function MapLayerSelector({ children, onSelect, selected }) {
  const [expanded, setExpanded] = useState(false);

  const handleExpanded = useCallback(() => {
    setExpanded(true);
  }, []);

  const handleOnSelect = useCallback(
    (selectedItem) => {
      onSelect(selectedItem);
      setExpanded(false);
    },
    [onSelect]
  );

  return (
    <div
      style={{
        width: "inherit",
        height: "inherit",
        pointerEvents: "all",
      }}
    >
      <div
        style={{
          position: "fixed",
          width: 32,
          height: 32,
          marginLeft: 10,
          marginTop: 295,
          zIndex: 1001,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-around",
          backgroundColor: "#ffffff",
        }}
      >
        {
          {
            default: (
              <DefaultLayerSelector onSelect={handleExpanded} selected={true} />
            ),
            satellite: (
              <SatelliteLayerSelector
                onSelect={handleExpanded}
                selected={true}
              />
            ),
            hydro: (
              <HydroLayerSelector onSelect={handleExpanded} selected={true} />
            ),
          }[selected]
        }
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "space-between",
          marginTop: 250,
          backgroundColor: "#ffffff",
          padding: 5,
          position: "fixed",
          marginLeft: 5,
          zIndex: 1002,
          width: 130,
          height: 70,
          animation: `${expanded ? "expandScale" : "packScale"} ease-in-out .75s forwards`,
          transformOrigin: "bottom left",
        }}
      >
        <DefaultLayerSelector onSelect={() => handleOnSelect("default")} />
        <SatelliteLayerSelector onSelect={() => handleOnSelect("satellite")} />
        {/* <HydroLayerSelector onSelect={() => handleOnSelect("hydro")} /> */}
      </div>
      {children}
    </div>
  );
}
